// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__3yJ4d","tab":"Tabs_tab__1Fmzt","tabActive":"Tabs_tabActive__3Hsgq"};